import {
    PXPAY_REQUEST,
    PXPAY_SUCCESS,
    PXPAY_FAILURE,
} from './../../constants';
  
const initialPxPayState = {
    loader: false,
    success: false,
    failed: false,
    payment: null,
};
  
export default (state = initialPxPayState, action) => {
  
    //This is to ensure immutability of state
    const newState = {...state};
  
    switch (action.type) {
    case PXPAY_REQUEST:
        newState.loader = true;
        newState.failed = false;
        newState.success = false;
        newState.payment = null;
        return newState;
    case PXPAY_SUCCESS:
        window.location.assign(action.data.redirectUrl);
        newState.payment = action.data;   
        newState.loader = false;    
        newState.success = true;
        newState.failed = false;
        return newState;
    case PXPAY_FAILURE:
        newState.loader = false;
        newState.failed = true;
        newState.success = false;
        newState.payment = null;
        return newState;
    default:
        return state;
    }
  
};
  